import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21ZM5 5V19H19V5H5ZM14 17H11V13H10V11H13V15H14V17ZM13 9H11V7H13V9Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "InfoSquareOutline"
);
